// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ShopPage_Wrapper__z06Zx","Container":"ShopPage_Container__2oFJk"};